export const dateToHTML = (d: Date | string | number) => {
	if (!d) return '';

	// Support milliseconds
	if (typeof d === 'number') d = new Date(d);

	if (d instanceof Date) {
		return [
			d.getFullYear(),
			(d.getMonth() + 1).toString().padStart(2, '0'),
			d.getDate().toString().padStart(2, '0'),
		].join('-');
	}

	const temp = d.split('/');
	if (temp.length && temp[0].length === 4)
		return d.replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3');

	return d.replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$1-$2');
};

export default dateToHTML;
